import React from "react"
import "./index.scss"

const BlankSlate = ({ text, description }) => (
  <div className="blank-slate">
    <span className="icon-slate" />
    <h3 className="text">{text}</h3>
    <p className="subtitle">{description}</p>
  </div>
)

export default BlankSlate
